<p>create-iomodule works!</p>
